import { Mobile, Pc } from '../../hooks/MediaQuery'
import Page2Pc from './Page2Pc'
import Page2Mobile from './Page2Mobile'
import { useEffect, useState } from 'react'
import { selectGoodsList } from '../../api/x_goods'
import { selectPopup } from '../../api/x_popup'
import { getSelectedCategory } from '../../utils/cookie'
import { useParams } from 'react-router-dom'

function Page2() {
  const [goods, setGoods] = useState([])
  const [popup, setPopup] = useState(null)
  let { id } = useParams()
  useEffect(() => {
    async function fetchPopup() {
      const response = await selectPopup({
        useYn: 'Y'
      })
      const data = response.data.data
      setPopup(data)
    }
    fetchPopup()

    async function fetchGoods() {
      const response = await selectGoodsList({
        useYn: 'Y',
        caSeq: id,
      })
      const data = response.data.data
      setGoods(data)
    }
    fetchGoods()
  }, [])
  return (
    <>
    
      <Pc>
        <Page2Pc goods={goods} popup={popup}/>
      </Pc>
      <Mobile>
        <Page2Mobile goods={goods} popup={popup}/>
      </Mobile>
    </>
  )
}

export default Page2
